import { useEffect, useState } from "react"
import { quotes } from "../siteData/quotes"
import { shuffleArray } from "../utils"

interface Quote {
  quote: string
  author: string
}

function useQuoteFetcher(url: string) {
  const [allQuotes, setAllQuotes] = useState<Quote[]>([])
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleNextQuote = () => {
    if (currentQuoteIndex === allQuotes.length - 1) {
      setAllQuotes([])
      setCurrentQuoteIndex(0)
      fetchData()
    } else {
      const nextQuoteIndex = currentQuoteIndex + 1
      setCurrentQuoteIndex(nextQuoteIndex)
    }
  }

  const handlePreviousQuote = () => {
    const prevQuoteIndex = currentQuoteIndex - 1
    setCurrentQuoteIndex(prevQuoteIndex)
  }

  const shareOnTwitter = () => {
    const { quote, author } = allQuotes[currentQuoteIndex]
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      quote + "\n- " + author
    )}`
    window.open(twitterUrl, "_blank")
  }

  const shareOnWhatsApp = () => {
    const { quote, author } = allQuotes[currentQuoteIndex]
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      quote + "\n- " + author
    )}`
    window.open(whatsappUrl, "_blank")
  }

  const fetchData = async () => {
    setLoading(true)
    // const { data } = await axios.get<Quote[]>(url)
    setAllQuotes(shuffleArray(quotes))
    setLoading(false)
  }

  useEffect(() => {
    if (allQuotes.length > 0) {
      setCurrentQuoteIndex(0)
    }
  }, [allQuotes])

  useEffect(() => {
    fetchData()
  }, [])

  const { quote, author } = allQuotes[currentQuoteIndex] || {}

  return {
    quote,
    author,
    currentQuoteIndex,
    handleNextQuote,
    handlePreviousQuote,
    shareOnTwitter,
    shareOnWhatsApp,
    loading,
  }
}

export default useQuoteFetcher
